// ink-component
import React from 'react';
import styled from 'styled-components';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { CSSWidthType } from '../../../../helpers/constants/cssPropTypes';
import { shimmerBase, shimmerRoll } from '../../_common/styles';

export interface ShimmerTextProps {
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** The width of the shimmer component measured in css length values. */
  width?: CSSWidthType;
  /** Number of rows. Only applicable with text variant. */
  rows?: number;
}

const ShimmerTextWrapper = styled.div`
  width: ${props => props.theme.width};
`;

const StyledShimmer = styled.div`
  ${shimmerBase};
  animation-name: ${props => shimmerRoll(props.theme.width)};
  height: ${props => props.theme.height};
  transform: scale(1, 0.7);
  width: ${props => props.theme.width};

  &:nth-child(even) {
    width: 94%;
  }
  &:nth-child(odd) {
    width: 100%;
  }
  &:nth-child(4n) {
    width: 98%;
  }
  &:last-child {
    width: 92%;
  }
  &:only-child {
    width: 100%;
  }
`;

const globalProps = getGlobalProps({});

/**
 * @purpose Paragraph-shaped animated shimmer
 * @group shimmer
 */
const ShimmerText = (props: ShimmerTextProps) => {
  // @ts-ignore
  const { className, style, width, rows } = props;

  const shimmerProps = {
    ...globalProps,
    'data-testid': props['data-testid'],
    className: 'ink-shimmer shimmer__variant-text',
  };

  const theme = {
    width,
    height: '20px',
  };

  return (
    <ShimmerTextWrapper theme={theme}>
      {[...Array(rows)].map((_e, i) => (
        <StyledShimmer key={`paragraph-${i}`} theme={theme} {...shimmerProps} />
      ))}
    </ShimmerTextWrapper>
  );
};

ShimmerText.defaultProps = {
  'data-testid': undefined,
  rows: 1,
  width: '100%',
};

ShimmerText.displayName = 'Shimmer.Text';

export default ShimmerText;
